import { hasAdminPermission } from './adminPermissions';

export const canManagePhysicalCardRecords = (user) => hasAdminPermission(user, 'manage_physical_cards');
